import { classNames } from "../lib/utils/classNames";
export const Divider = ({ className }: { className?: string }) => (
  <hr className={classNames("text-grey-dark", className)} />
);
